import { useState } from 'react'

import { BuildingSelect } from '../../Building'
import { FlatSelect } from '../../Flat'
import { RequestSelect } from '../../Request'
import { Container } from '../Container'

function EntitySelects() {
  const [value, setValue] = useState(null)

  function handleSelectItem(item) {
    setValue(item)
  }

  return (
    <>
      <div
        style={{
          marginBottom: 20,
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'pre',
        }}
      >
        Selected value - {JSON.stringify(value, null, 4)}
      </div>
      <Container label='Async builidng select with search'>
        <BuildingSelect onSelectItem={handleSelectItem} />
      </Container>
      <Container label='Async flat select with search'>
        <FlatSelect onSelectItem={handleSelectItem} />
      </Container>
      <Container label='Async request select with search'>
        <RequestSelect onSelectItem={handleSelectItem} />
      </Container>
    </>
  )
}

export default EntitySelects
